import { createTypes } from "reduxsauce";

export default createTypes(
    `
    SET_VIDEO_GALLERY_MODAL_OPEN
`,
    {
        prefix: "videoGallery/"
    }
);
